
document.addEventListener("DOMContentLoaded", () => {

  /**************************
   * Transparent Header JS *
  *************************/
  const transparentBanner = document.querySelector(
    '[data-transparent-header="true"]'
  );

  if (!transparentBanner) return;

  // document.body.classList.add('transparent-header-enabled');

  const header = document.querySelector('sticky-header');
  if (header) {
    header.classList.add('transparent_header');
  }

});

document.addEventListener("DOMContentLoaded", function () {
  var tabs = document.querySelectorAll(".product__overview ul.tabs li");

  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      var tab_id = tab.getAttribute("data-tab");

      tabs.forEach(function (t) {
        t.classList.remove("current");
      });

      var tabContents = document.querySelectorAll(".product__overview .tab-content");
      tabContents.forEach(function (content) {
        content.classList.remove("current");
      });

      tab.classList.add("current");
      document.getElementById(tab_id).classList.add("current");
    });
  });
});

/**
 * <product-card-slider>
 * Standalone image carousel for product cards.
 * Does NOT conflict with Shopify's native <slider-component>.
 * Uses data-pcs-* attributes for scoping — never queries outside itself.
 */

if (!customElements.get('product-card-slider')) {
  class ProductCardSlider extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.swipeThreshold = 50;
      this.isTransitioning = false;
      this.mobileBreakpoint = 990;
      this.scrollTimeout = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-pcs-track]');
      this.slides = this.querySelectorAll('[data-pcs-slide]');
      this.prevBtn = this.querySelector('[data-pcs-prev]');
      this.nextBtn = this.querySelector('[data-pcs-next]');
      this.counterCurrent = this.querySelector('[data-pcs-counter-current]');
      this.counterTotal = this.querySelector('[data-pcs-counter-total]');
      this.progressBar = this.querySelector('[data-pcs-progress-bar]');
      this.progressFill = this.querySelector('[data-pcs-progress-fill]');

      if (!this.track || this.slides.length === 0) return;

      this.totalSlides = this.slides.length;

      // Set total count
      if (this.counterTotal) {
        this.counterTotal.textContent = this.totalSlides;
      }

      // Hide arrows if only 1 slide
      if (this.totalSlides <= 1) {
        const buttonsWrapper = this.querySelector('[data-pcs-buttons]');
        if (buttonsWrapper) buttonsWrapper.style.display = 'none';
        return;
      }

      this.bindEvents();
      this.goToSlide(0, false);
      this.updateProgressBar(0);
      this.bindMobileScroll();
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.prev();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.next();
        });
      }

      // Stop parent slider-component from capturing drag/pointer events
      this.track.addEventListener('mousedown', (e) => e.stopPropagation());
      this.track.addEventListener('pointerdown', (e) => e.stopPropagation());

      // Keyboard navigation when focused
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.stopPropagation();
          this.prev();
        } else if (e.key === 'ArrowRight') {
          e.stopPropagation();
          this.next();
        }
      });
    }

    /**
     * Mobile scroll-snap detection
     * On mobile, pcs-track uses overflow-x: auto + scroll-snap
     * We listen to the scroll event to determine which slide is active
     */
    bindMobileScroll() {
      if (!this.track) return;

      this.track.addEventListener('scroll', () => {
        // Only process on mobile
        if (window.innerWidth >= this.mobileBreakpoint) return;

        // Debounce scroll events for performance
        if (this.scrollTimeout) {
          cancelAnimationFrame(this.scrollTimeout);
        }

        this.scrollTimeout = requestAnimationFrame(() => {
          this.onMobileScroll();
        });
      }, { passive: true });
    }

    onMobileScroll() {
      if (!this.track || this.totalSlides <= 1) return;

      const trackWidth = this.track.scrollWidth;
      const slideWidth = trackWidth / this.totalSlides;
      const scrollLeft = this.track.scrollLeft;

      // Calculate current slide index based on scroll position
      const newIndex = Math.round(scrollLeft / slideWidth);
      const clampedIndex = Math.max(0, Math.min(newIndex, this.totalSlides - 1));

      if (clampedIndex !== this.currentIndex) {
        this.currentIndex = clampedIndex;

        // Update aria attributes
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('pcs-slide--active', i === clampedIndex);
          slide.setAttribute('aria-hidden', i !== clampedIndex);
        });

        // Update counter if exists
        if (this.counterCurrent) {
          this.counterCurrent.textContent = clampedIndex + 1;
        }

        this.lazyLoadNearby(clampedIndex);
      }

      // Update progress bar smoothly based on continuous scroll position
      // This gives a fluid progress feel even mid-swipe
      const scrollProgress = scrollLeft / (trackWidth - this.track.clientWidth);
      const clampedProgress = Math.max(0, Math.min(scrollProgress, 1));

      // Map scroll progress to slide-based progress
      // At scroll 0% → slide 1 of N → bar width = 1/N
      // At scroll 100% → slide N of N → bar width = N/N = 100%
      const barWidth = ((1 - clampedProgress) * (1 / this.totalSlides) + clampedProgress) * 100;

      this.updateProgressBarDirect(barWidth);
    }


    prev() {
      if (this.isTransitioning) return;
      const newIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.totalSlides - 1;
      this.goToSlide(newIndex);
    }

    next() {
      if (this.isTransitioning) return;
      const newIndex = this.currentIndex < this.totalSlides - 1 ? this.currentIndex + 1 : 0;
      this.goToSlide(newIndex);
    }

    goToSlide(index, animate = true) {
      if (index < 0 || index >= this.totalSlides) return;

      this.isTransitioning = animate;
      this.currentIndex = index;

      if (window.innerWidth >= this.mobileBreakpoint) {
        const offset = -(index * 100);
        this.track.style.transition = animate ? 'transform 0.3s ease' : 'none';
        this.track.style.transform = `translateX(${offset}%)`;
      }

      // Translate track
      const offset = -(index * 100);
      this.track.style.transition = animate ? 'transform 0.3s ease' : 'none';
      this.track.style.transform = `translateX(${offset}%)`;

      // Update active slide aria
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('pcs-slide--active', i === index);
        slide.setAttribute('aria-hidden', i !== index);
      });

      // Update counter
      if (this.counterCurrent) {
        this.counterCurrent.textContent = index + 1;
      }

      this.updateProgressBar(index);

      // Lazy-load adjacent images
      this.lazyLoadNearby(index);

      if (animate) {
        setTimeout(() => {
          this.isTransitioning = false;
        }, 300);
      }
    }

    /**
     * Update progress bar based on discrete slide index
     * Used by desktop (button navigation) and initial load
     */
    updateProgressBar(index) {
      if (!this.progressFill || this.totalSlides <= 1) return;
      const progress = ((index + 1) / this.totalSlides) * 100;
      this.progressFill.style.width = `${progress}%`;
    }

    /**
     * Update progress bar with a direct width value
     * Used by mobile scroll for smooth continuous updates
     */
    updateProgressBarDirect(widthPercent) {
      if (!this.progressFill || this.totalSlides <= 1) return;
      this.progressFill.style.width = `${widthPercent}%`;
    }

    lazyLoadNearby(index) {
      const indices = [index - 1, index, index + 1];
      indices.forEach((i) => {
        if (i >= 0 && i < this.totalSlides) {
          const img = this.slides[i].querySelector('img[loading="lazy"]');
          if (img && !img.dataset.pcsLoaded) {
            img.loading = 'eager';
            img.dataset.pcsLoaded = 'true';
          }
        }
      });
    }
  }

  customElements.define('product-card-slider', ProductCardSlider);
}

/**
 * Android-only helper class
 * Adds `is-android` to <html> and <body> so CSS can target Android devices reliably.
 */
(function () {
  try {
    const ua = navigator.userAgent || '';
    const platform = navigator.userAgentData && navigator.userAgentData.platform ? navigator.userAgentData.platform : '';
    const isAndroid = /Android/i.test(ua) || /Android/i.test(platform);

    if (!isAndroid) return;

    document.documentElement.classList.add('is-android');

    const addToBody = () => {
      if (document.body) document.body.classList.add('is-android');
    };

    if (document.body) addToBody();
    else document.addEventListener('DOMContentLoaded', addToBody, { once: true });
  } catch (e) {
    // no-op
  }
})();


window.addEventListener('load', function () {
  document.querySelectorAll('.js-hide-until-loaded').forEach(function(el) {
    el.style.opacity = '1';
    el.style.visibility = 'visible';
  });
});